<div class="mx-auto text-center mb-5">
  <div class="container">
    <h1>404 - Seite nicht gefunden</h1>
    <p>Die von Ihnen angeforderte Seite wurde entweder nie erstellt oder existiert nicht mehr.</p>
    <p>Bitte überprüfen Sie die URL auf mögliche Tippfehler. Wenn alles korrekt ist und Sie glauben, dass es sich um
      einen Fehler handelt, können Sie uns gerne per E-Mail oder Telefonisch darüber informieren.</p>

    <button class="btn btn-success text-center me-5" routerLink="/startseite">Zur Startseite</button>
    <button class="btn btn-success text-center" (click)="history.back()">Zurück</button>
  </div>
</div>
